module.exports = __webpack_public_path__ + "static/investment-advisory-services-hero.0d6704ce.webp";